const cases = [
  {
    icon: 'ri-briefcase-line',
    title: 'コンサルティング会社',
    description:
      'オーナーのSNS（X）の運用を一部代行。毎月10社、様々な企業の代表とのマッチングを実現。カジュアルなつながりから案件化にいたる流れを構築。',
  },
  {
    icon: 'ri-computer-line',
    title: 'システム開発会社',
    description:
      '採用要件をクリアできるエンジニアがなかなか見つからないケースにおいて、必要な人材を具体的にヒアリングした上でエンジニアを確保。面談合格率80%以上を実現。',
  },
  {
    icon: 'ri-exchange-line',
    title: 'M&A仲介会社',
    description:
      '広告を運用して「明確な譲渡意向はないが興味はある」オーナーを集め、M&Aの可能性を初回面談で提案、譲渡意思が固まったオーナーを仲介会社に紹介。',
  },
];

const CasesSection = () => {
  return (
    <section id="cases" className="py-20 bg-[#f7f9f7]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Case Studies</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">導入事例</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cases.map((item) => (
            <div key={item.title} className="bg-white rounded-lg p-7 border border-gray-100">
              <div className="w-10 h-10 flex items-center justify-center bg-[#3d6b4f]/10 rounded-md mb-5">
                <i className={`${item.icon} text-[#3d6b4f] text-lg`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CasesSection;
